import * as zExt from "@redotech/rpc/ext";
import { shopperAgentStrategyIdFormat } from "@redotech/shopper-agent-strategy-id";
import * as z from "zod";

export const getShopperAgentStrategy = {
  name: "getShopperAgentStrategy" as const,
  input: z.object({ strategyId: shopperAgentStrategyIdFormat.schema }),
  output: z.object({
    /** Missing from servers that predate the unified field. */
    guidance: z.string().optional(),
    goalGuidance: z.string(),
    outreachGuidance: z.string(),
    mongoDiscountId: zExt.objectId().nullable(),
  }),
};
